import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import { ROUTES } from "./vertical-menu-routes.config";
import { HROUTES } from "../horizontal-menu/navigation-routes.config";
import { SidebarSyncService } from 'app/shared/services/sidebar-sync.service';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from "ngx-device-detector";
import { ConfigService } from "../services/config.service";
import { Subscription, combineLatest, Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { LayoutService } from "../services/layout.service";
import { AuthService } from "app/core/service/auth/auth.service";
import { ContactUsService } from "app/modules/contact-us/_services/contact-us.service";
import { InquiryService } from "app/modules/inquiry-list/_services/inquiry.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations,
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("toggleIcon") toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = "assets/img/login.png";
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  type: any;
  private destroy$ = new Subject<void>();
  contactUsCount = 0;
  unclaimCount = 0;
  claimCount = 0;
  audioCount = 0;
  overviewCount = 0;
  blockAICount = 0;
  email = "";
  userId = "";
  inquiryCount = 0;
  UploadCount = 0;
  accessMap: { [key: string]: boolean } = {};

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private authservice: AuthService,
    private contactUsService: ContactUsService,
    private inquiryService: InquiryService,
    private sidebarSyncService: SidebarSyncService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  calculateAccess(title: string): boolean {
    if (title === "Youtube Content ID") {
      if (
        this.authservice.isRH() &&
        this.authservice.currentUserValue.asset_label.label_id == ""
      ) {
        return false;
      }
      return true;
    }
    return true;
  }
  insertBadge(title, count) {
    const mergedCount = this.contactUsCount + this.inquiryCount;
    for (let config in this.menuItems) {
      if (this.menuItems[config].title == title) {
        this.menuItems[config].badge = count;
        this.menuItems[config].badgeClass =
          "badge badge-pill badge-danger float-right mt-1";
      }
      if (this.menuItems[config].title === "Communication") {
        for (let submenu of this.menuItems[config].submenu) {
          for (let menu of submenu.submenu) {
            if (menu.title == title) {
              menu.badge = count;
              submenu.badge = mergedCount;

              menu.badgeClass =
                "badge badge-pill badge-danger float-right mt-1";
              submenu.badgeClass =
                "badge badge-pill badge-danger float-right  mt-1";
            }
          }
          if (submenu.title == title) {
            submenu.badge = count;
            this.menuItems[config].badge = mergedCount;

            submenu.badgeClass =
              "badge badge-pill badge-danger float-right  mt-1";
            this.menuItems[config].badgeClass =
              "badge badge-pill badge-danger float-right mt-1";
          }
        }
      }

      if (
        this.menuItems[config].title === "Payments" ||
        this.menuItems[config].title === "YouTube Claims" ||
        this.menuItems[config].title === "YouTube Partner" ||
        this.menuItems[config].title === "YouTube Scanning" ||
        this.menuItems[config].title === "Upload" ||
        this.menuItems[config].title === "Upload Drafts" ||
        this.menuItems[config].title === "YouTube Claims"
      ) {
        for (let submenu of this.menuItems[config].submenu) {
          for (let menu of submenu.submenu) {
            if (menu.title == title) {
              menu.badge = count;

              menu.badgeClass =
                "badge badge-pill badge-danger float-right mt-1";
            }
          }
          if (submenu.title == title) {
            submenu.badge = count;

            submenu.badgeClass =
              "badge badge-pill badge-danger movemoreright float-right mt-1";
          }
        }
      }
    }
  }

  ngOnInit() {
    this.email = this.authservice.currentUserValue.email;
    this.userId = this.authservice.currentUserValue?._id || "";
    this.authservice.currentUser$.subscribe((user) => {
      if (this.authservice.currentUserValue) {
        this.type = this.authservice.currentUserValue.type;
        let uploadType = 1;
        if (this.authservice.currentUserValue.type == 4) {
          if (this.authservice.currentUserValue.upload_menu) {
            uploadType = this.authservice.currentUserValue.upload_menu
          } else {
            uploadType = 0
          }
        }
        this.menuItems = ROUTES;
        this.updateAssetLabelsPath();
        if (this.authservice.isAdminCategory()) {
          this.menuItems = this.menuItems.filter((m) => {
            return m.title != "Contact Us";
          });
          for (let config of this.menuItems) {
            if (config.title === "Communication") {
              config.badge = "";
              break;
            }
          }

          this.contactUsService.getBadgeCount();
          this.contactUsService.badgeCount$.subscribe((count) => {
            this.contactUsCount = count;
            this.insertBadge("Contact Us", count);
            this.cdr.markForCheck();
          });

          this.getoverview();
          this.getUnclaimed();
          this.getaudioCount();
          this.getUploadCount();
          this.getBlockAICount();
          this.sidebarSyncService.refreshUploadCount$.subscribe(() => {
            this.getUploadCount();
            this.getBlockAICount();
            if (!this.authservice.isRHTeam()) this.getAssetPendingReview();
          });
          this.getPendingRequestCount();
        } else {
          this.menuItems = this.menuItems.filter((m) => {
            return m.title != "Communication";
          });
        }

        setTimeout(() => {
          this.menuItems = this.menuItems.filter((item) => {
            if (item.title === "Upload" && uploadType !== 1) {
              return false;
            }
            return true;
          });
        }, 0);

        if (!this.authservice.isRHTeam()) {
          this.getAssetPendingReview();
          this.sidebarSyncService.refreshRhUploadCount$.subscribe(() => {
            this.getAssetPendingReview();
          });
        }
        this.cdr.markForCheck();
      }
    });

    this.menuItems.forEach((item) => {
      this.accessMap[item.title] = this.calculateAccess(item.title);
    });
  }

  private updateAssetLabelsPath() {
    if (!this.menuItems || !this.userId) return;

    this.menuItems = this.menuItems.map(item => {
      if (item.title === "Asset Labels") {
        // Use the string format since your HTML uses routerLink="{{menuItem.path}}"
        return {
          ...item,
          path: `/right-holders/super-content-owner/${this.userId}`
        };
      }
      return item;
    });
  }

  getPendingRequestCount() {
    this.inquiryService.getBadgeCount();
    this.inquiryService.badgeCount$.subscribe((count) => {
      this.inquiryCount = count;
      this.insertBadge("Pending Requests", count);
      this.cdr.markForCheck();
    });
  }

  getAssetPendingReview() {
    const isRH = this.authservice.isRH();

    this.inquiryService.getAssetPendingReview({
      type: isRH ? 2 : 1,
      asset_label: isRH ? this.authservice.currentUserValue?.asset_label?.labelName : "",
    });

    this.inquiryService.assetsCount$
      .pipe(takeUntil(this.destroy$)) // Always use takeUntil
      .subscribe((count) => {
        this.inquiryCount = count;
        this.insertBadge("Uploads Pending Review", count);
        if (isRH) this.insertBadge("Upload", count);
        this.cdr.markForCheck();
      });

    if (!isRH && !this.authservice.isRHTeam()) {
      // Trigger all fetches immediately
      this.inquiryService.getClaiming();
      this.inquiryService.getAllowList();
      this.inquiryService.getRightDownList();
      // this.inquiryService.getAiContentRemovalList();
      // Combine all 3 streams into ONE subscription
      combineLatest([
        this.inquiryService.claimCount$,           // Stream 1
        this.inquiryService.allowListCount$,       // Stream 2
        this.inquiryService.copyRightDownListCount$, // Stream 3
        //this.inquiryService.aiContentRemovalCount$ // Stream 4
      ])
        .pipe(takeUntil(this.destroy$))
        .subscribe(([claimCount, allowCount, takedownCount]) => {

          // Update individual badges
          this.insertBadge("Manual Claiming", claimCount);
          this.insertBadge("Allowlist", allowCount);
          this.insertBadge("Copyright Takedown", takedownCount);
          const totalYouTubeClaims = claimCount + allowCount + takedownCount ;

          this.insertBadge("YouTube Claims", totalYouTubeClaims);
          this.cdr.markForCheck();
        });
    }

  }

  getaudioCount() {
    this.contactUsService.getaudioCount();
    this.contactUsService.audioCount$.subscribe((count) => {
      this.audioCount = count;
      this.insertBadge("YouTube Scanning", count);
      this.insertBadge("Monitored Videos", count);
      this.cdr.markForCheck();
    });
  }

  getBlockAICount() {
    this.inquiryService.getBlockAIPendingReview();
    this.inquiryService.blockAICount$.subscribe((count) => {

      this.blockAICount = count;
      this.insertBadge("Block AI", count);
      this.cdr.markForCheck();
    });
  }

  getUploadCount() {
    this.inquiryService.getAssetPendingReview({
      type: this.authservice.isRH() ? 2 : 1,
      asset_label: this.authservice.isRH()
        ? this.authservice.currentUserValue?.asset_label?.labelName
        : "",
    });
    this.inquiryService.assetsCount$.subscribe((count) => {
      var uploadCount = count;

      this.contactUsService.getUploadCount();
      this.contactUsService.uploadCount$.subscribe((ucount) => {
        this.UploadCount = ucount;
        this.insertBadge("Upload", ucount + uploadCount);
        this.insertBadge("Upload Drafts", ucount);
        this.cdr.markForCheck();
      });
    });
  }

  getUnclaimed() {
    this.contactUsService.getUnclaimCount();
    this.contactUsService.unclaimedCount$.subscribe((count) => {
      this.unclaimCount = count;
      this.insertBadge("YouTube Partner", count);
      this.insertBadge("DRM YouTube videos", count);
      this.cdr.markForCheck();
    });
  }

  getoverview() {
    this.contactUsService.getOverviewCount();
    this.contactUsService.overviewCount$.subscribe((count) => {
      this.overviewCount = count;
      this.insertBadge("Payments", count);
      this.insertBadge("Payment History", count);
      this.insertBadge("Overview", count);
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe(
      (templateConf) => {
        if (templateConf) {
          this.config = templateConf;
        }
        this.loadLayout();
        this.cdr.markForCheck();
      }
    );

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      (collapse) => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      }
    );
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(
      (() => {
        this.innerWidth = event.target.innerWidth;
        this.loadLayout();
      }).bind(this),
      500
    );
  }

  filterRoutes(routes: any) {
    return routes.filter((route) => {
      if (route.title === "Youtube Content ID") {
        if (
          this.authservice.isRH() &&
          this.authservice.currentUserValue.asset_label.labelName == ""
        ) {
          return false;
        }
      }
      if (route.title === "YouTube Licensing") {
        if (this.authservice.isRH() || this.authservice.isTrueSuperContentOwner()) {
          if (
            this.authservice.currentUserValue.contractCount &&
            this.authservice.currentUserValue.contractCount > 0
          ) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }

      return true;
    });
  }

  removeSublicensingPaymentDetails(menu: any[]): any[] {
    return menu.map((item) => {
      if (item.submenu && item.submenu.length > 0) {
        // Remove "Sublicensing Payment Details" from submenu

        if (item.title === "Payments") {
          if (this.authservice.isRH() || this.authservice.isTrueSuperContentOwner()) {
            if (
              this.authservice.currentUserValue.contractCount &&
              this.authservice.currentUserValue.contractCount > 0
            ) {
              return item;
            } else {
              item.submenu = item.submenu.filter(
                (sub) => sub.title !== "Sublicensing Payment Details"
              );
              return item;
            }
          }
          return item;
        }
        return item;
      }
      return item;
    });
  }

  loadLayout() {
    if (this.config.layout.menuPosition === "Top") {
      // Horizontal Menu
      if (this.innerWidth < 1200) {
        // Screen size < 1200
        this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === "Side") {
      // Vertical Menu{
      this.menuItems = ROUTES;
    }

    this.menuItems = this.filterRoutes(ROUTES);
    this.menuItems = this.removeSublicensingPaymentDetails(this.menuItems);
    this.updateAssetLabelsPath();

    this.collapseSidebar = !!this.config.layout.sidebar.collapsed;

    if (this.collapseSidebar) {
      this.logoUrl = "assets/img/login.png";
    } else {
      if (this.config.layout.sidebar.backgroundColor === "white") {
        this.logoUrl = "assets/img/logo-dark.png";
      } else {
        this.logoUrl = "assets/img/login.png";
      }
    }

    // if (this.config.layout.sidebar.collapsed) {
    //   this.collapseSidebar = true;
    // } else {
    //   this.collapseSidebar = false;
    // }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    // Update logo based on collapsed state
    if (conf.layout.sidebar.collapsed) {
      this.logoUrl = "assets/img/login.png";
    } else {
      this.logoUrl = this.config.layout.sidebar.backgroundColor === "white"
        ? "assets/img/logo-dark.png"
        : "assets/img/login.png";
    }

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.config.layout.sidebar.collapsed) {
      this.logoUrl = this.config.layout.sidebar.backgroundColor === "white"
        ? "assets/img/logo-dark.png"
        : "assets/img/login.png";
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.config.layout.sidebar.collapsed) {
      this.logoUrl = "assets/img/small_logo.png";
    }
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }
}
